import { render, staticRenderFns } from "./SwapTemplateModal.vue?vue&type=template&id=c8309a76&scoped=true"
import script from "./SwapTemplateModal.vue?vue&type=script&lang=js"
export * from "./SwapTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8309a76",
  null
  
)

export default component.exports